var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_w","data-current-name":_vm.page.current.name,"data-current-slug":_vm.page.current.slug}},[_c('LayoutHeader'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('LayoutFooter'),_vm._v(" "),_c('LayoutAssets')],1)}
var staticRenderFns = []

export { render, staticRenderFns }